import React from "react";
import { IconButton, Paper } from "@mui/material";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import { styled } from "@mui/material/styles";
import WebMAPToolTip from "components/WebMAPToolTip";

const StyledPaper = styled(Paper)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  minWidth: "unset",
}));

/**
 * @summary Hides all visible layers
 *
 * @param {object} props
 * @returns {object} React
 */
const ThemeToggler = React.memo((props) => {
  return (
    (props.showThemeToggler && (
      <WebMAPToolTip title="Превключване между тъмна и светла цветова тема">
        <StyledPaper>
          <StyledIconButton
            aria-label="Превключване на цвета на темата"
            onClick={(e) => {
              props.toggleMUITheme();
            }}
          >
            <Brightness4Icon />
          </StyledIconButton>
        </StyledPaper>
      </WebMAPToolTip>
    )) ||
    null
  );
});

export default ThemeToggler;
